import React, { useEffect, useState, useRef, createRef }  from 'react';

const ContentPopup = ({id, myRef, autoOpen, content, cancelButton, beforeClose, notWide, contextClass, modalStyle, modalClass, onReady, revealWhenReady }) => {
  const modalRef = myRef == undefined ? useRef() : myRef;
  const contentRef = useRef();
  // A form inside the popup renders intermediate states before it settles (fields populating, nested price
  // pickers fetching their lists). With revealWhenReady it stays invisible until its layout stops changing,
  // then fades in, so the user never sees a half-built form. Off (the default) keeps the old instant render.
  const [revealed, setRevealed] = useState(!revealWhenReady);

  const hide = (e) => {
    e.preventDefault();
    if(beforeClose != undefined) { beforeClose(); };
    modalRef.current.style.display = "none";
  }

  const show = () => {
    modalRef.current.style.display = "block";
    if(onReady != undefined) { onReady() }
  }

  useEffect(() => {
    if(autoOpen) { show(); }
  }, []);

  // Reveal once the content has settled: reset a short timer on every layout change and reveal when it has
  // been quiet for a moment; a hard cap guarantees the form always appears even if it never stops changing.
  useEffect(() => {
    if(!revealWhenReady) { return; }

    let settleTimer;
    const scheduleSettle = () => {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(() => setRevealed(true), 150);
    };
    scheduleSettle();

    const observer = (typeof ResizeObserver !== 'undefined' && contentRef.current) ? new ResizeObserver(scheduleSettle) : null;
    if(observer) { observer.observe(contentRef.current); }

    const hardCap = setTimeout(() => setRevealed(true), 1200);

    return () => {
      clearTimeout(settleTimer);
      clearTimeout(hardCap);
      if(observer) { observer.disconnect(); }
    };
  }, []);

  return (
    <div className="modal" ref={modalRef} id={id} >
      <div className={`modal-content ${notWide ? '' : 'modal-content-wide'} ${modalClass || ''}`} style={modalStyle}>
        <span className="close" onClick={hide} >&times;</span>
        <div ref={contentRef} className={`${contextClass != undefined ? contextClass : 'Content'}`}
             style={revealWhenReady ? { opacity: revealed ? 1 : 0, transition: 'opacity 180ms ease' } : undefined} > {content} </div>

        {cancelButton && <button onClick={hide}> Cancel </button>}
      </div>
    </div>
  )
}

export {
  ContentPopup
};
